/**
 * How long the workstation takes, as every surface says it.
 *
 * Plain data, so today's pages and the new design's /desktop (which may not import a styled-components module,
 * design-system §7b) read the same words. Moved here from src/components/onboarding/JourneyStepper.tsx on
 * 2026-10-01, which re-exports both, so its existing importers are unchanged.
 */

/**
 * How long the DEDICATED WORKSTATION takes to finish its first boot.
 *
 * Deliberately distinct from step 4's time hint (src/config/newAccountJourney.ts): under the
 * instant-workspace policy the workspace itself opens immediately and chat
 * works right away (that's the ~2 minutes of orientation), while the
 * workstation keeps building in the background for materially longer. Four
 * surfaces used to quote four different numbers (~2 min / 2–4 min / several
 * minutes / a few minutes) — this is the single frontend source of truth.
 * The backend's matching copy lives in
 * functions/src/prest0nSession/taskQueue.ts (buildWorkstationBootingReply).
 */
export const WORKSTATION_BOOT_ESTIMATE = 'several minutes';

/**
 * Waking an ASLEEP workstation (idle-lifecycle, 2026-08-18) is much faster
 * than first-time setup: a GCE resume/start plus service boot. Same SSOT
 * rule as WORKSTATION_BOOT_ESTIMATE — every surface quotes this constant.
 * Backend copy siblings: taskQueue.ts buildWorkstationWakingReply and
 * prest0nVm/wakeWorkspace.ts MESSAGES.
 */
export const WORKSTATION_WAKE_ESTIMATE = 'about a minute';
